<template>
<el-collapse-item :name="name" class="mt-2">
    <template slot="title">
        <div>
            <span class="c-darkfour filter-header">{{ itemTitle }}</span>
            <span 
                :class="`badge ${getPrimaryColor} filter-selected badge-filter-modal-position`"
                v-if="renderBadgeCondition"
            >
                1
            </span>
        </div>
    </template>
    <!-- CALENDAR CONDITION -->
    <div id="calendar" :class="getPrimaryColor" class="row d-flex align-items-center" v-if="type === 'calendar'">
        <div class="col pr-0">
            <el-input placeholder="DD/MM/YYYY" v-model="selected.start" v-mask="'##/##/####'" :class="getPrimaryColor">
                <span slot="prefix">
                    <Calendar />
                </span>
            </el-input>
        </div>
        <div class="col-1 text-center">
            <h6 class="mb-0 regular">a</h6>
        </div>
        <div class="col pl-0">
            <el-input placeholder="DD/MM/YYYY" v-model="selected.end" v-mask="'##/##/####'" :class="getPrimaryColor">
                <span slot="prefix">
                    <Calendar />
                </span>
            </el-input>
        </div>
        <div class="col-12 mt-3">
            <vc-date-picker 
                v-model="selected" 
                is-range 
                :color="`${getPrimaryColor}-${getWhiteLabel.toLowerCase().replace(/ /g, '')}`"
                :model-config="modelConfig"
                :attributes="[{
                    key: 'today',
                    highlight: {
                        fillMode: 'outline'
                    },
                    dates: new Date(),
                }]"
            />
        </div>
    </div>

    <!-- RADIO CONDITION -->
    <el-radio-group class="w-100 d-flex flex-column" v-model="selected" v-else-if="type === 'radio'">
        <el-radio 
            v-for="(item, index) in radioItems" 
            :label="item.value || index" 
            :key="index"
            :class="getPrimaryColor"
        > 
        {{ item.label || item }} 
        </el-radio>
    </el-radio-group>
    
    <!-- INPUT RANGE CONDITION -->
    <div id="input-range" :class="getPrimaryColor" class="row d-flex align-items-center mb-2" v-if="type == 'input'">
        <div class="col pr-0">
            <el-input v-mask="'############'" v-model="selected.minValue" :class="getPrimaryColor">
                <span slot="prefix" :class="`c-${getPrimaryColor}four`">
                    De
                </span>
            </el-input>
        </div>
        <div class="col-1 text-center">
            <h6 class="mb-0 regular">-</h6>
        </div>
        <div class="col pl-0">
            <el-input :placeholder="`ex.: ${example}`"  v-mask="'############'" v-model="selected.maxValue" :class="getPrimaryColor">
                <span slot="prefix" :class="`c-${getPrimaryColor}four`">
                    Até
                </span>
            </el-input>
        </div>
    </div>
    <div id="input-range" :class="getPrimaryColor" class="row d-flex align-items-center mb-2" v-if="type == 'input-money'">
        <div class="col pr-0">
            <Money
                :min="0"
                v-model="selectedMoney.minValue"
                class="input-money-filter"
                v-bind="money"
                @input="selectedMoney.minValue = Math.abs(selectedMoney.minValue)"
                :class="getPrimaryColor"
            />
            <span :class="`c-${getPrimaryColor}four filter-prefix left`">
                De
            </span>
        </div>
        <div class="col-1 text-center">
            <h6 class="mb-0 regular">-</h6>
        </div>
        <div class="col pl-0">
            <Money
                :min="0"
                v-model="selectedMoney.maxValue"
                class="input-money-filter"
                v-bind="money"
                @input="selectedMoney.maxValue = Math.abs(selectedMoney.maxValue)"
                :class="getPrimaryColor"
            />
            <span :class="`c-${getPrimaryColor}four filter-prefix`">
                Até
            </span>
        </div>
    </div>

    <el-button type="text" :class="`c-${getPrimaryColor}four`" @click='emptyFilter()'>Limpar</el-button>

</el-collapse-item>
</template>

<script>

// Libraries
import _ from 'lodash'

// Icons
import Calendar from '@/components/icons/Calendar'

// Utils
import { cleanVariable } from '@/utils/cleanner'
import {
    Money
} from 'v-money'


export default {
    props: {
        name: {
            type: String,
            required: true
        },
        type: {
            type: String,
            required: true
        },
        renderBadgeCondition: {
            required: true
        },
        itemTitle: {
            type: String,
            required: true
        },
        filter: {
            required: true
        },
        example: {
            type: [String, Number],
            required: false
        },
        
        // Radio Prop
        radioItems: Array
    },
    data() {
        return {
            modelConfig: {
                type: 'string',
                mask: 'DD/MM/YYYY'
            },
            selected: _.cloneDeep(this.filter),
            money: {
                decimal: ',',
                thousands: '.',
                precision: 2,
            },
            selectedMoney: _.cloneDeep(this.filter),
            emptyAll: false
        }
    },
    watch: {
        selected: {
            handler(val) {
                if (val && _.isNil(val.minValue) && this.type == 'input-money') {
                    // If the selected was cleaned, i have to clean selectedMoney too.
                    // But, to avoid infinite loops between watches, i'll use a condition at selectedMoney too

                    this.selectedMoney = {
                        minValue: 0,
                        maxValue: 0
                    }
                    this.emptyAll = true
                }
                this.$emit('returnedFilter', { correlation: this.name, filter: this.selected })
            },
            deep: true
        },
        filter() {
            this.selected = this.filter
        },
        selectedMoney: {
            handler() {
                if (this.emptyAll) {
                    this.emptyAll = false
                    return
                }
                const { minValue, maxValue } = this.selectedMoney
                this.selected = {
                    minValue,
                    maxValue
                }
            },
            deep: true
        }
    },
    methods: {
        emptyFilter() {
            switch (this.type) {
                case 'input':
                case 'calendar':
                    this.selected = {}
                    break;
                case 'input-money':
                    this.selectedMoney = {
                        minValue: 0,
                        maxValue: 0
                    }
                    break
                default:
                    this.selected = cleanVariable(this.selected)
                    break;
            }
        },
    },
    components: {
        Calendar,
        Money
    },
}

</script>

<style lang="scss">

.badge-filter-modal-position {
    position: absolute;
    left: 285.5px - 20px; // ! 20px = width
}

.filter-selected {
    width: 20px;
    height: 20px;
    background-color: #3D5DFC;
    color: white;
    text-align: center;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 700;
    line-height: 22px
}

.input-money-filter {
    border-radius: 32px;
    border: 1px solid #dfe2eb;
    padding-left: 40px;
    height: 32px;
    width: 100%;
    font-size: 12px;
    position: relative;
    background-color: #fbfdfe;
}

.filter-prefix {
    position: absolute;
    left: 10px;
    top: 6px;
    font-size: 12px;
    &.left {
        left: 10px + 11px;
    }
}

</style>